<ng-container *ngIf="height">
  <div [ngStyle]="verticalScrollStyle">
    <div [ngStyle]="widthStyle">
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="width">
  <div [ngStyle]="horizontalScrollStyle">
    <div [ngStyle]="widthStyle">
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
